import { connect } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../../redux/ApplicationState";
import AgencyDetails from "../components/AgencyDetails";
import { saveTabSessionReAuthStorageResp } from "../../../actions/TabSessionStorage";
import { ReAuthTabData } from "../../../models/TabSessionStorage";
import { getSendCommunicationAuthType } from "../../../actions/Master";
import { getListResult } from "../../../utils";

const mapStateToProps = ({
    loggedInUserState,
    tabSessionStorageReAuthState,
    reAuthServiceProviderState,
    masterSendCommunicationAuthTypeState,
    reAuthReferralDetailState
}: ApplicationState) => ({
    loggedInUser: loggedInUserState.response,
    TabSessionStorage: tabSessionStorageReAuthState,
    reAuthServiceProviderState: reAuthServiceProviderState.response,
    masterSendCommunicationAuthTypeState: getListResult(masterSendCommunicationAuthTypeState.response),
    reAuthReferralDetailState: reAuthReferralDetailState.response,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
    return {
      saveTabSessionStorage: (sessionData: ReAuthTabData) => {
        dispatch(saveTabSessionReAuthStorageResp(sessionData));
      },
      getSendCommunicationAuthType: () => {
        dispatch(getSendCommunicationAuthType());
      },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AgencyDetails);